export default {
    rainbow: {
        palette: {
            brand: '#1aa287',
            success: '#79c9a6',
        },
    },
};
